import React from 'react';
import ReactSVG from 'react-svg';
import chevron from 'chevron-small.svg';

export default function MLSBreadcrumbs({ listing }) {
  return (
    <ul className="page-content-breadcrumb mls">
      <li>
        <a
          href={window.Routes.for_sale_path()}
          aria-label="For Sale"
          data-turbolinks="false"
        >
          For Sale
        </a>
      </li>
      <ReactSVG src={chevron} />
      <li>
        <a
          href={window.Routes.for_sale_path({ areas: listing?.area?.slug })}
          aria-label={listing?.area?.name}
          data-turbolinks="false"
        >
          {listing?.area?.name}
        </a>
      </li>
      <ReactSVG src={chevron} />
      <li>
        <a
          href={window.Routes.for_sale_path({
            listing_url: window.Routes.mls_address_show_path(
              listing?.address_show_url
            ),
          })}
          aria-label={listing?.address}
          data-turbolinks="false"
        >
          {listing?.address}
        </a>
      </li>
    </ul>
  );
}
